import axios from 'axios';
import VueCookies from 'vue-cookies';
import store from '../store';
import router from '@/router';

const instance = axios.create({
  baseURL: 'https://api.moallem.sch.ir/inventory/v1/',
});

instance.interceptors.request.use(config => {
  const token = VueCookies.get("ACCESS-TOKEN");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  config.params = {
    ...config.params,
    inventory: store.getters.getInventory, // Modify with the desired query parameter and value
  };

  return config;
});

instance.interceptors.response.use(
  response => response,
  async error => {
    if (error.response && error.response.status === 401) {
      // Token expired, trigger refresh
      try {
        await store.dispatch("getAccessTokenFromRefreshToken");
        const newToken = VueCookies.get("ACCESS-TOKEN");

        // Retry the original request with the new token
        const originalRequest = error.config;
        originalRequest.headers.Authorization = `Bearer ${newToken}`;
        return instance(originalRequest);
      } catch (refreshError) {
        // Handle refresh token error (e.g., user needs to reauthenticate)
        console.error('Refresh token failed', refreshError);
        throw refreshError;
      }
    }
    else if(error.response && error.response.status === 404){
      router.push({name: '404'})
    }
    else if (error.response && error.response.status >= 500 && error.response.status <= 600) {
      if (router.currentRoute.value.path.split('/').reverse()[0] != '500')
        router.push({ path: router.currentRoute.value.path + '/500' })
    }
    else if (error.code == 'ERR_NETWORK') {
      if (router.currentRoute.value.path.split('/').reverse()[0] != 'network-err')
        router.push({ path: router.currentRoute.value.path + '/network-err' });
    }
    return Promise.reject(error);
  }
);

export default instance;
